import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../features/auth/authSlice";
import { useDisplayCurrency } from "../../components/LeaderboardReward/useDisplayCurrency";
import { BOARD_LABEL, useGetRewardsQuery } from "../../features/leaderboards/leaderboardsSlice";
import { periodLabel } from "../../lib/leaderboard/format";

/** Every leaderboard prize this user won (credited to the Reward balance), newest first. */
export const LeaderboardRewards = () => {
  const user = useSelector(selectCurrentUser);
  const { data, isLoading, isError, refetch } = useGetRewardsQuery({ page: 1, limit: 50, userId: user?.id });
  const { money } = useDisplayCurrency();
  const rows = data?.data ?? [];
  return (
    <div className="font-dashboard pt-8 pb-12 lg:px-4">
      <Helmet><title>My Leaderboard Rewards</title></Helmet>
      <div className="container-lg">
        <div className="bg-black rounded-lg px-4 lg:px-10 py-6">
          <div className="flex items-center justify-between mb-6">
            <h1 className="text-white text-2xl font-medium">My Leaderboard Rewards</h1>
            <Link to="/app/leaderboards" className="text-primary text-sm hover:underline">← Leaderboard</Link>
          </div>
          {isLoading ? (
            <div className="flex justify-center py-16"><div className="h-10 w-10 border-4 border-primary border-t-transparent rounded-full animate-spin"></div></div>
          ) : isError && !data ? (
            <div className="flex flex-col items-center py-16">
              <p className="text-red-400">Could not load your rewards.</p>
              <button className="mt-4 bg-primary py-2 px-6 rounded-lg text-black font-medium" onClick={() => refetch()}>Try again</button>
            </div>
          ) : rows.length === 0 ? (
            <p className="text-white/50 text-center py-16">No prizes yet. Finish a day or a month in the reward positions and your prize lands here, credited to your Reward balance.</p>
          ) : (
            <div className="space-y-2">
              {rows.map((r) => (
                <div key={r._id} className="rounded-xl bg-gray-800 px-4 py-3">
                  <div className="flex items-center justify-between">
                    <span className={`font-bold ${r.status === "revoked" ? "text-white/40 line-through" : "text-white"}`}>{money(r.amount)}</span>
                    <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${r.status === "credited" ? "bg-green-900 text-green-300" : r.status === "revoked" ? "bg-red-900 text-red-300" : "bg-gray-700 text-white/70"}`}>{r.status}</span>
                  </div>
                  <p className="text-white/80 text-sm mt-1">#{r.rank} · {BOARD_LABEL[r.board]} · {periodLabel(r.periodType, r.periodKey)}</p>
                  {r.status === "revoked" && r.revokeReason && <p className="text-red-400 text-xs mt-1">Revoked: {r.revokeReason}</p>}
                  {r.createdAt && <p className="text-white/40 text-xs mt-1">{new Date(r.createdAt).toLocaleString()}</p>}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
